/**
 * Build query params the same way assets/filters do: URLSearchParams with
 * repeated keys (no axios `key[]=` serialization).
 */
export function buildApprovalsSearchParams(
  values: Record<string, string | number | string[] | undefined | null>
): URLSearchParams {
  const params = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value == null) {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item != null && item !== "") {
          params.append(key, String(item));
        }
      });
      return;
    }
    if (value !== "") {
      params.append(key, String(value));
    }
  });
  return params;
}
